export { default as capitalize } from './capitalize';
export { default as currencyToNumber } from './currency-to-number';
export { default as currency } from './currency';
export { default as normalizeNumber } from './normalize-number';
export { default as phone } from './phone';
export { default as cpf } from './cpf';
export { default as mask } from './mask';
export { default as numberWithDots } from './number-with-dots';
export { default as toPercent } from './to-percent';
export { default as phoneEmail } from './phone-email';
